import { TRANSACTION_TYPES } from '../utils/constants';

const threatsRoutes = [

    {
        path: '/threats',
        name: 'ThreatsPage',
        component: () => import('../views/threats/ThreatsComponent.vue'),
        meta: {
            requiresAuth: true,
            permission: 'threats',
            module: 'risksManagement',
            planFeature: 'custom_catalogs',


        }
    },
    {
        path: '/threats/create',
        name: 'CreateThreatComponent',
        component: () => import('../views/threats/ThreatsManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            permission: ['threats', 'createThreat'],
            module: 'risksManagement',


        }
    },
    {
        path: '/threats/edit/:threatId',
        name: 'EditThreatComponent',
        component: () => import('../views/threats/ThreatsManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.EDIT, threatId: route.params.threatId }),
        meta: {
            requiresAuth: true,
            permission: ['threats', 'editThreat'],
            module: 'risksManagement',


        }
    },
    {
        path: '/threats/show/:threatId',
        name: 'ShowThreatComponent',
        component: () => import('../views/threats/ThreatsManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.SHOW, threatId: route.params.threatId }),
        meta: {
            requiresAuth: true,
            permission: ['threats', 'viewThreat'],
            module: 'risksManagement',


        }
    },

];

export default threatsRoutes;